<template>
  <div class="device-detail-location-bd" :class="{ 'full-screen': fullScreen }">
    <div class="device-detail-location-wrap">
      <div id="container" ref="container"></div>
      <!-- 缩放工具 -->
      <div class="amap-tool">
        <div class="location" @click="toolHandle('center')">
          <i class="icon icon-dianziweilan"></i>
        </div>
        <div class="zoom ubv">
          <div class="ub-f1" @click="toolHandle('add')">
            <i class="icon icon-shebeiyewuxinxi1"></i>
          </div>
          <div class="bar"></div>
          <div class="ub-f1" @click="toolHandle('reduce')">
            <i class="icon icon-shebeiyewuxinxi11"></i>
          </div>
        </div>
      </div>
      <!-- 围栏 -->
      <div class="tab-box tab ub">
        <div class="ub" v-if="!isShowFenceDialog && (propsFuncView.deviceDetail_location_fence || propsFuncView.deviceDetail_location_positioning)">
          <div class="ub-f1 line" v-if="propsFuncView.deviceDetail_location_fence" :class="{ cur: showTab === 'fence' }" @click="changeTab('fence')">
            <i class="icon icon-dianziweilan"></i>
            <span>&ensp;{{ $t('dms_device_detail_location.she_bei_wei_lan') }}</span>
          </div>
          <div class="ub-f1 line" v-if="propsFuncView.deviceDetail_location_positioning" :class="{ cur: showTab === 'location' }" @click="changeTab('location')">
            <i class="icon icon-dingwei"></i>
            <span>&ensp;{{ $t('dms_device_detail_location.fu_zhu_ding_wei') }}</span>
          </div>
        </div>
        <div class="full-btn" @click="fullScreen = !fullScreen">
          <i v-if="!fullScreen" class="icon icon-quanping2"></i>
          <i v-if="fullScreen" class="icon icon-quanping11"></i>
        </div>
      </div>
      <!-- 地图区域检索 -->
      <div class="tab-box ub" v-if="mapType !== 'google'">
        <el-autocomplete
          size="medium"
          v-model="searchKey"
          :fetch-suggestions="searchLocation"
          :placeholder="$t('dms_device_detail_location.qsrwzxx')"
          :trigger-on-focus="false"
          style="width: 250px"
          @select="selectLocation"
        >
          <i class="icon icon-search" slot="suffix" style="font-size: 17px; margin-right: 6px; line-height: 35px"></i>
          <template slot-scope="{ item }">
            <div class="name">{{ item.name }}</div>
            <div style="font-size: 12px; line-height: 16px; color: #999; margin: -4px 0 6px">{{ item.address }}</div>
          </template>
        </el-autocomplete>
      </div>
      <template v-if="showTab === 'fence' && propsFuncView.deviceDetail_location_fence">
        <!-- 围栏列表 -->
        <div class="fence-list" v-if="!isShowFenceDialog">
          <h1 class="tit">
            {{ $t('dms_device_detail_location.wei_lan_lie_biao') }}
            <span @click="isShow = !isShow">
              {{ isShow ? $t('dms_device_detail_location.shou_qi') : $t('dms_device_detail_location.zhan_kai') }}
              <i class="icon icon-xiala" v-if="!isShow"></i>
              <i v-else class="icon icon-shangla"></i>
            </span>
          </h1>
          <div style="padding: 0 16px 16px" v-if="isShow">
            <div class="add-fence" @click="onFenceAdd()">
              <i class="icon icon-add"></i>
              <span>&ensp;{{ $t('dms_device_detail_location.tian_jia_wei_lan') }}</span>
            </div>
            <ul>
              <li class="ub" v-for="(item, index) in fenceList" :key="index" :class="[{ disable: !item.state }, { cur: curFence.fenceId === item.fenceId }]">
                <span class="ub-f1 line1" @click="onCurrentFence(item)">{{ item.fenceName }}</span>
                <i v-if="item.state" class="icon icon-jinyong1" @click="onFenceState(item)"></i>
                <i v-else class="icon icon-qiyong" @click="onFenceState(item)"></i>
                <i class="icon icon-bianji" @click="onFenceUpdate(item)"></i>
                <i class="icon icon-shanchu" @click="onFenceDel(item)"></i>
              </li>
            </ul>
          </div>
        </div>
        <!-- 新增围栏 -->
        <div class="aside-box" v-if="isShowFenceDialog">
          <h1 class="tit">{{ fenceDialogTitle }}</h1>
          <div style="padding: 0 16px 16px">
            <div class="ub aside-tab" v-if="mapType !== 'google'">
              <div class="ub-f1" :class="{ cur: form.fenceType === 1 }" @click="changeFenceTab(1)">
                {{ $t('dms_device_detail_location.yuan_xing') }}
              </div>
              <div class="ub-f1" :class="{ cur: form.fenceType === 3 }" @click="changeFenceTab(3)">
                {{ $t('dms_device_detail_location.xing_zheng_qu_yu') }}
              </div>
            </div>
            <div style="height: 10px" v-else></div>
            <el-form label-position="top" label-width="80px">
              <el-form-item :label="$t('dms_device_detail_location.wei_lan_ming_cheng')" v-if="form.fenceType === 1">
                <el-input v-model="form.fenceName"></el-input>
              </el-form-item>
              <el-form-item :label="$t('dms_device_detail_location.ding_wei_fan_wei')" v-if="form.fenceType === 1">
                <el-slider style="margin: 0 4px" @input="changeSider" v-model="form.fenceScope" :max="10000" :min="500"></el-slider>
                <div class="ub marks-tip">
                  <div>500m</div>
                  <div>10000m</div>
                </div>
              </el-form-item>
              <el-form-item :label="$t('dms_device_detail_location.xing_zheng_qu_yu')" v-if="form.fenceType === 3">
                <custom-select
                  type="tree"
                  v-model="form.fenceData"
                  url="NationTree"
                  :placeholder="$t('Common.com_please_select')"
                  width="100%"
                  :params="{ level: 2 }"
                  :props="{
                    label: 'name',
                    value: 'name',
                    checkStrictly: true,
                    emitPath: false,
                  }"
                  @change="selectArea"
                ></custom-select>
              </el-form-item>
            </el-form>
            <div class="ub">
              <el-button style="width: 100%" @click="onFenceCancel()">{{ $t('Common.com_cancel') }}</el-button>
              <el-button type="primary" style="width: 100%" @click="onFenceSave()">{{ $t('Common.com_save') }}</el-button>
            </div>
          </div>
        </div>
      </template>
      <template v-if="showTab === 'location'&& propsFuncView.deviceDetail_location_positioning">
        <!-- 辅助列表 -->
        <div class="fence-list" v-if="!isShowLocationDialog">
          <h1 class="tit">
            {{ $t('dms_device_detail_location.fu_zhu_ding_wei') }}
            <span @click="isShow = !isShow">
              {{ isShow ? $t('dms_device_detail_location.shou_qi') : $t('dms_device_detail_location.zhan_kai') }}
              <i class="icon icon-xiala" v-if="!isShow"></i>
              <i v-else class="icon icon-shangla"></i>
            </span>
          </h1>
          <div style="padding: 0 16px 16px" v-if="isShow">
            <div class="add-fence" @click="onLocationAdd()">
              <i class="icon icon-add"></i>
              <span>&ensp;{{ $t('dms_device_detail_location.fu_zhu_ding_wei') }}</span>
            </div>
            <ul>
              <li class="ub" v-for="(item, index) in locationList" :key="index" :class="[{ disable: !item.state }, { cur: curLocation.locationId === item.locationId }]">
                <span class="ub-f1 line1" @click="onCurrentLocation(item)">{{ item.gpsAddress }}</span>
                <i v-if="item.state" class="icon icon-jinyong1" @click="onLocationState(item)"></i>
                <i v-else class="icon icon-qiyong" @click="onLocationState(item)"></i>
                <i class="icon icon-bianji" @click="onLocationUpdate(item)"></i>
                <i class="icon icon-shanchu" @click="onLocationDel(item)"></i>
              </li>
            </ul>
          </div>
        </div>
        <!-- 新增辅助 -->
        <div class="aside-box" v-if="isShowLocationDialog">
          <h1 class="tit">{{ fenceDialogTitle }}</h1>
          <div style="padding: 0 16px 16px">
            <el-form label-position="top" label-width="80px">
              <el-form-item :label="$t('dms_device_detail_location.dang_qian_wei_zhi')">
                <div class="address">
                  <i class="el-icon-location"></i>
                  {{ locForm.gpsAddress }}
                </div>
              </el-form-item>
              <el-form-item :label="$t('dms_device_detail_location.ding_wei_fan_wei')">
                <el-slider style="margin: 0 4px" v-model="locForm.radius" :max="10000" :min="500" @input="changeSider"></el-slider>
                <div class="ub marks-tip">
                  <div>500m</div>
                  <div>10000m</div>
                </div>
              </el-form-item>
            </el-form>
            <div class="ub">
              <el-button style="width: 100%" @click="onLocationCancel()">{{ $t('Common.com_cancel') }}</el-button>
              <el-button type="primary" style="width: 100%" @click="onLocationSave()">{{ $t('Common.com_save') }}</el-button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

let map = null; // 地图
let circle = null;
let dit = null;
let PlaceSearch = null; // 搜索类

var pi = 3.14159265358979324;
var a = 6378245.0;
var ee = 0.00669342162296594323;

export default {
  props: {
    deviceInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    propsFuncView: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      mapType: 'google1111', // 地图类型
      fullScreen: false, // 是否全屏
      searchKey: '', // 搜索关键字

      isShow: true,
      showTab: '', // fence, location
      isShowFenceDialog: false,
      fenceDialogTitle: '',
      isShowLocationDialog: false,
      curFence: {},
      curLocation: {},
      fenceList: [],
      locationList: [],
      form: {
        fenceId: '',
        deviceId: '',
        fenceAddress: '',
        fenceData: '',
        fenceName: '',
        fenceScope: 500,
        fenceType: 1,
        state: 1,
        zoomLevel: 16,
      },
      locForm: {
        locationId: '',
        deviceId: '',
        gpsAddress: '',
        lat: '',
        lng: '',
        radius: 500,
        state: 1,
      },
    };
  },
  mounted: function () {
    this.resetForm = JSON.stringify(this.form);
    this.initMap(() => {
      this.changeTab('fence');
      this.fenceDevice();
    });
  },
  methods: {
    transformLon(x, y) {
      var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
      ret += ((20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0) / 3.0;
      ret += ((20.0 * Math.sin(x * pi) + 40.0 * Math.sin((x / 3.0) * pi)) * 2.0) / 3.0;
      ret += ((150.0 * Math.sin((x / 12.0) * pi) + 300.0 * Math.sin((x / 30.0) * pi)) * 2.0) / 3.0;
      return ret;
    },
    transformLat(x, y) {
      var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
      ret += ((20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0) / 3.0;
      ret += ((20.0 * Math.sin(y * pi) + 40.0 * Math.sin((y / 3.0) * pi)) * 2.0) / 3.0;
      ret += ((160.0 * Math.sin((y / 12.0) * pi) + 320 * Math.sin((y * pi) / 30.0)) * 2.0) / 3.0;
      return ret;
    },
    outOfChina(lat, lon) {
      if (lon < 72.004 || lon > 137.8347) {
        return true;
      }
      if (lat < 0.8293 || lat > 55.8271) {
        return true;
      }
      return false;
    },
    // 国际坐标=>中国坐标
    wgs_gcj_encrypts: function (wgLat, wgLon) {
      var point = {};
      if (this.outOfChina(wgLat, wgLon)) {
        point.lat = wgLat;
        point.lng = wgLon;
        return point;
      }
      var dLat = this.transformLat(wgLon - 105.0, wgLat - 35.0);
      var dLon = this.transformLon(wgLon - 105.0, wgLat - 35.0);
      var radLat = (wgLat / 180.0) * pi;
      var magic = Math.sin(radLat);
      magic = 1 - ee * magic * magic;
      var sqrtMagic = Math.sqrt(magic);
      dLat = (dLat * 180.0) / (((a * (1 - ee)) / (magic * sqrtMagic)) * pi);
      dLon = (dLon * 180.0) / ((a / sqrtMagic) * Math.cos(radLat) * pi);
      var lat = wgLat + dLat;
      var lon = wgLon + dLon;
      point.lat = lat;
      point.lon = lon;
      return point;
    },
    // 区域搜索
    searchLocation: function (key, cb) {
      PlaceSearch.search(this.searchKey, () => {
        cb(this.poiList);
      });
    },
    // 区域搜索回调
    searchLocationCallback: function (result) {
      this.poiList = result.poiList.pois;
    },
    // 选择区域地图渲染
    selectLocation: function (item) {
      map.setCenter([item.location.lng, item.location.lat], true);
      map.add(
        new AMap.Marker({
          position: new AMap.LngLat(item.location.lng, item.location.lat),
        })
      );
    },
    // 切换Tab(围栏/辅助)
    changeTab: function (name) {
      if (name === 'fence') {
        this.isShowFenceDialog = false;
        this.onFenceList();
      }
      if (name === 'location') {
        this.onLocationList();
      }
      this.showTab = name;
    },
    // 初始化地图
    initMap: function (cb) {
      cb = cb || function () {};
      if (window.AMap) {
        map = new window.AMap.Map('container', {
          center: [104.937478, 37.839575],
          zoom: 5,
          mapStyle: 'amap://styles/whitesmoke',
        });
        this.initMapPlugin();
        cb();
        return;
      }
      this.$loadJS('https://webapi.amap.com/maps?v=2.0&key=f94794d8324cc241ee358e7985a6f2d3', () => {
        map = new window.AMap.Map('container', {
          center: [104.937478, 37.839575],
          zoom: 5,
          mapStyle: 'amap://styles/whitesmoke',
        });
        this.initMapPlugin();
        cb();
      });
    },
    // 初始化地图插件
    initMapPlugin: function () {
      //  搜索功能
      window.AMap.plugin(['AMap.PlaceSearch'], () => {
        // 设置PlaceSearch属性
        const PlaceSearchOptions = {
          datatype: 'all',
          citylimit: false,
          pageSize: 20, // 每页结果数,默认10
          pageIndex: 1, // 请求页码，默认1
          extensions: 'poi', // 返回信息详略，默认为base（基本信息）
        };
        PlaceSearch = new window.AMap.PlaceSearch(PlaceSearchOptions);
        window.AMap.Event.addListener(PlaceSearch, 'complete', this.searchLocationCallback);
      });
      // 地址解析
      window.AMap.plugin('AMap.Geocoder', () => {});
      // 行政区查询
      window.AMap.plugin('AMap.DistrictSearch', () => {});
      // 拖拽跟随
      map.on('mapmove', () => {
        if (circle && dit) {
          const center = map.getCenter();
          circle.setCenter(center);
          dit.setCenter(center);
        }
      });
      map.on('moveend', () => {
        if (circle && dit) {
          this.getGeocoder();
        }
      });
    },
    // 缩放工具
    toolHandle: function (type) {
      if (type === 'center') {
        const { lat, lng } = this.deviceInfo;
        if (!lat || !lng) {
          return;
        }
        const center = new window.AMap.LngLat(lng, lat);
        map.setCenter(center);
      }
      if (type === 'add') {
        const zoom = map.getZoom();
        map.setZoom(zoom + 0.8);
      }
      if (type === 'reduce') {
        const zoom = map.getZoom();
        map.setZoom(zoom - 0.8);
      }
    },
    // 位置信息
    getGeocoder: function () {
      const geocoder = new window.AMap.Geocoder();
      const { lng, lat } = map.getCenter();
      geocoder.getAddress([lng, lat], (status, result) => {
        if (status === 'complete' && result.info === 'OK') {
          this.locForm.gpsAddress = result.regeocode.formattedAddress;
        }
      });
    },
    // 清除圆圈
    fenceClear: function () {
      const arrs = map.getAllOverlays();
      map.remove(arrs); // 移除所有围栏
      this.fenceDevice();
    },
    // 围栏列表
    onFenceList: function () {
      this.$getJSON(apis.DeviceFenceList, {
        deviceId: this.deviceInfo.deviceId,
      }).then((res) => {
        this.fenceList = res.data;
        this.fenceRenter(this.fenceList);
      });
    },
    // 渲染围栏列表
    fenceRenter: function (fenceList) {
      this.curFence = {};
      const list = fenceList.filter((t) => t.state && t.fenceType === 1);
      this.fenceClear();
      // 围栏
      list.forEach((item) => {
        const pos = JSON.parse(item.fenceData);
        this.drawCircle(pos.lng, pos.lat, item.fenceScope);
      });
      // 区域
      const list1 = fenceList.filter((t) => t.state && t.fenceType === 3);
      list1.forEach((item) => {
        this.drawArea(item.fenceData, () => {
          map.setFitView();
        });
      });
      map.setFitView();
    },
    // 渲染围栏
    drawCircle: function (lng, lat, radius = 500, isLoc) {
      if (!lng && !lat) {
        const center = map.getCenter();
        lng = center.lng;
        lat = center.lat;
      }
      const ditItem = new window.AMap.CircleMarker({
        center: [lng, lat],
        radius: 8, // 半径
        strokeOpacity: 1,
        strokeWeight: 2,
        fillOpacity: 1,
        fillColor: isLoc ? '#16D071' : '#F9C851',
        strokeColor: '#FFFFFF',
        zIndex: 100,
      });
      map.add(ditItem);
      const circleItem = new window.AMap.Circle({
        center: [lng, lat],
        radius: radius, // 半径
        strokeOpacity: 1,
        strokeWeight: 3,
        fillOpacity: 0.3,
        fillColor: isLoc ? '#16D071' : '#F9C851',
        strokeColor: isLoc ? '#16D071' : '#F9C851',
        zIndex: 50,
      });
      map.add(circleItem);
      return { dit: ditItem, circle: circleItem };
    },
    // 渲染区域
    drawArea: function (keywords, cb) {
      cb = cb || function () {};
      const district = new window.AMap.DistrictSearch({
        subdistrict: 0, // 获取边界不需要返回下级行政区
        extensions: 'all', // 返回行政区边界坐标组等具体信息
        // level: 'province' // 查询行政级别为区
      });
      district.search(keywords, (status, result) => {
        var bounds = result.districtList[0].boundaries;
        var polygons = [];
        if (bounds) {
          for (var i = 0, l = bounds.length; i < l; i++) {
            // 生成行政区划polygon
            var polygon = new window.AMap.Polygon({
              strokeWeight: 3,
              path: bounds[i],
              fillOpacity: 0.3,
              fillColor: '#F9C851',
              strokeColor: '#F9C851',
            });
            polygons.push(polygon);
          }
          map.add(polygons);
          cb(result);
        }
      });
    },
    // 围栏tab切换(围栏范围/围栏区域)
    changeFenceTab: function (value) {
      const title = this.$t('dms_device_detail_location.xin_zeng_wei_lan');
      if (this.fenceDialogTitle !== title) {
        return;
      }
      this.form = JSON.parse(this.resetForm);
      this.form.fenceType = value;
      this.fenceClear(); // 清空地图
      if (value === 1) {
        const cur = this.drawCircle();
        circle = cur.circle;
        dit = cur.dit;
        map.setFitView([circle]);
      }
      if (value === 3) {
        const { lat, lng } = this.deviceInfo;
        map.setCenter(new window.AMap.LngLat(lng || 104.937478, lat || 37.839575));
        map.setZoom(5);
      }
    },
    // 选中围栏
    onCurrentFence: function (item) {
      if (this.curFence.fenceId === item.fenceId) {
        this.curFence = {};
        this.fenceRenter(this.fenceList);
        return;
      }
      this.curFence = item;
      this.fenceClear();
      if (item.fenceType === 3) {
        this.drawArea(item.fenceData);
        map.setFitView();
        return;
      } else {
        const pos = JSON.parse(item.fenceData);
        const cur = this.drawCircle(pos.lng, pos.lat, item.fenceScope);
        map.setFitView([cur.circle]);
      }
    },
    // 新增围栏
    onFenceAdd: function () {
      this.fenceDialogTitle = this.$t('dms_device_detail_location.xin_zeng_wei_lan');
      this.changeFenceTab(1);
      this.isShowFenceDialog = true;
    },
    // 编辑围栏
    onFenceUpdate: function (row) {
      this.fenceDialogTitle = this.$t('dms_device_detail_location.bian_ji_wei_lan');
      row.fenceScope = Number.parseInt(row.fenceScope, 10);
      this.$setFormatData(this.form, row);
      this.fenceClear(); // 清空地图
      this.isShowFenceDialog = true;
      if (this.form.fenceType === 1) {
        const pos = JSON.parse(row.fenceData);
        const cur = this.drawCircle(pos.lng, pos.lat, row.fenceScope);
        circle = cur.circle;
        dit = cur.dit;
        map.setFitView([circle]);
      }
      if (this.form.fenceType === 3) {
        this.drawArea(row.fenceData);
        map.setFitView();
      }
    },
    // 取消围栏(新增/编辑)
    onFenceCancel: function () {
      this.isShowFenceDialog = false;
      this.fenceRenter(this.fenceList);
    },
    // 保存围栏(新增/编辑)
    onFenceSave: function () {
      // 区域
      if (this.form.fenceType === 3) {
        this.form.fenceScope = 0;
      }
      // 围栏
      if (this.form.fenceType === 1) {
        const { lng, lat } = map.getCenter();
        this.form.fenceData = JSON.stringify({ lng, lat });
      }
      if (!this.form.fenceName) {
        const msg = this.$t('dms_device_detail_location.wlmcbt');
        this.$message.error(msg);
        return;
      }
      this.form.deviceId = this.deviceInfo.deviceId;
      this.form.zoomLevel = map.getZoom();
      const title = this.$t('dms_device_detail_location.xin_zeng_wei_lan');
      // 新增
      if (this.fenceDialogTitle === title) {
        this.$postJSON(apis.DeviceFenceAdd, this.form).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.isShowFenceDialog = false;
          this.onFenceList();
        });
        return;
      }
      // 编辑
      this.$postJSON(apis.DeviceFenceUpdate, this.form).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.isShowFenceDialog = false;
        this.onFenceList();
      });
    },
    // 删除围栏
    onFenceDel: function (row) {
      this.$showConfirm(this.$t('dms_device_detail_location.nqdyscxzdwlm'))
        .then(() => {
          this.$postJSON(`${apis.DeviceFenceDelete}/${row.fenceId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_delete_success'),
              type: 'success',
            });
            this.onFenceList();
          });
        })
        .catch(() => {});
    },
    // 围栏禁用/启用
    onFenceState: function (row) {
      const tips = row.state ? this.$t('dms_device_detail_location.nqdyjyxzdwlm') : this.$t('dms_device_detail_location.nqdyqyxzdwlm');
      this.$showConfirm(tips)
        .then(() => {
          this.$setFormatData(this.form, row);
          this.form.state = row.state ? 0 : 1;
          this.$postJSON(apis.DeviceFenceUpdate, this.form).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.onFenceList();
          });
        })
        .catch(() => {});
    },
    // 辅助列表
    onLocationList: function () {
      this.$getJSON(apis.DeviceLocationList, {
        deviceId: this.deviceInfo.deviceId,
      }).then((res) => {
        this.locationList = res.data;
        this.fenceLosRenter(this.locationList);
      });
    },
    // 渲染辅助列表
    fenceLosRenter: function (fenceList) {
      this.curLocation = {};
      const list = fenceList.filter((t) => t.state);
      this.fenceClear();
      list.forEach((item) => {
        this.drawCircle(item.lng, item.lat, item.radius, true);
      });
      map.setFitView();
    },
    // 选中辅助
    onCurrentLocation: function (item) {
      if (this.curLocation.locationId === item.locationId) {
        this.curLocation = {};
        this.fenceLosRenter(this.locationList);
        return;
      }
      this.curLocation = item;
      this.fenceClear();
      const cur = this.drawCircle(item.lng, item.lat, item.radius, true);
      map.setFitView([cur.circle]);
    },
    // 新增辅助
    onLocationAdd: function () {
      const title = this.$t('dms_device_detail_location.xzfzdw');
      this.isShowLocationDialog = true;
      this.fenceDialogTitle = title;
      this.fenceClear();
      const cur = this.drawCircle(null, null, 500, true);
      dit = cur.dit;
      circle = cur.circle;
      map.setFitView([circle]);
    },
    // 编辑辅助
    onLocationUpdate: function (item) {
      const title = this.$t('dms_device_detail_location.bjfzdw');
      this.fenceDialogTitle = title;
      this.$setFormatData(this.locForm, item);
      this.fenceClear();
      this.isShowLocationDialog = true;
      const cur = this.drawCircle(item.lng, item.lat, item.radius, true);
      dit = cur.dit;
      circle = cur.circle;
      map.setFitView([circle]);
    },
    // 保存辅助(新增/编辑)
    onLocationSave: function () {
      const { lng, lat } = map.getCenter();
      const title = this.$t('dms_device_detail_location.xzfzdw');
      this.locForm.lat = lat;
      this.locForm.lng = lng;
      this.locForm.deviceId = this.deviceInfo.deviceId;
      if (this.fenceDialogTitle === title) {
        this.$postJSON(apis.DeviceLocationAdd, this.locForm).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.isShowLocationDialog = false;
          this.onLocationList();
        });
        return;
      }
      this.$postJSON(apis.DeviceLocationUpdate, this.locForm).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.isShowLocationDialog = false;
        this.onLocationList();
      });
    },
    // 辅助删除
    onLocationDel: function (row) {
      this.$showConfirm(this.$t('dms_device_detail_location.nqdyscxzdfzdwm'))
        .then(() => {
          this.$postJSON(`${apis.DeviceLocationDelete}/${row.locationId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_delete_success'),
              type: 'success',
            });
            this.onLocationList();
          });
        })
        .catch(() => {});
    },
    // 辅助禁用/启用
    onLocationState: function (row) {
      const tips = row.state ? this.$t('dms_device_detail_location.nqdyjyxzdfzdwm') : this.$t('dms_device_detail_location.nqdyqyxzdfzdwm');
      this.$showConfirm(tips)
        .then(() => {
          this.$setFormatData(this.locForm, row);
          this.locForm.state = row.state ? 0 : 1;
          this.$postJSON(apis.DeviceLocationUpdate, this.locForm).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.onLocationList();
          });
        })
        .catch(() => {});
    },
    // 取消辅助(新增/编辑)
    onLocationCancel: function () {
      this.isShowLocationDialog = false;
      this.fenceLosRenter(this.locationList);
    },
    // 变更圆半径
    changeSider: function (value) {
      circle.setRadius(value);
      map.setFitView([circle]);
    },
    // 选择区域
    selectArea: function () {
      this.fenceClear();
      this.drawArea(`${this.form.fenceData}`, (result) => {
        this.form.fenceName = result.districtList[0].name;
        this.form.fenceAddress = result.districtList[0].name;
        map.setFitView();
      });
    },
    // 设备位置
    fenceDevice: function () {
      const { lat, lng } = this.deviceInfo;
      if (!lat || !lng) {
        return;
      }
      const point = this.wgs_gcj_encrypts(lat, lng);
      var marker = new AMap.Marker({
        content: '<div class="map-marker"><div class="marker-img"></div><div class="marker"></div></div>',
        // position: new AMap.LngLat(lng, lat),
        position: new AMap.LngLat(point.lon, point.lat),
        offset: new window.AMap.Pixel(-6, -6),
      });
      map.add(marker);
      // 创建信息实例
      // var infoWindow = new window.AMap.InfoWindow({
      //   offset: new window.AMap.Pixel(0, -14),
      //   content: `<div class='product'><div class='ub'><div class='img-box'><img src='${
      //     this.deviceInfo.productImage && this.deviceInfo.productImage[0] ? this.deviceInfo.productImage[0].attachPath : ''
      //   }' alt /></div><div class='info'><h1>${this.deviceInfo.productCode}</h1><p>${this.deviceInfo.bodyNum}</p></div></div></div>`
      // });
      // // 打开信息窗体
      // infoWindow.open(map, new window.AMap.LngLat(lng, lat));
      // const curDit = this.fenceCenter(lng, lat, '#0D9AE0');
      // map.add(curDit);
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.device-detail-location-bd {
  position: relative;
  height: calc(100% - 72px);

  .map-marker {
    position: relative;
    z-index: 10;
    .marker-img {
      position: absolute;
      z-index: 10;
      top: -48px;
      left: 50%;
      transform: translateX(-50%);
      width: 41px;
      height: 45px;
      background-image: url('../../../../images/map/device.png');
      background-repeat: no-repeat;
      background-size: 100%;
    }
    .marker {
      margin: 0 auto;
      width: 12px;
      height: 12px;
      background: #0d9ae0;
      border: 2px solid #ffffff;
      border-radius: 6px;
    }
  }

  .gm-control-active.gm-fullscreen-control {
    display: none;
  }
  .gm-style-mtc button {
    font-size: 14px !important;
  }
  .gm-svpc {
    display: none;
  }
  .gm-bundled-control {
    display: none !important;
  }
  &.full-screen {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
    height: auto;
    margin: 0;
    padding: 0;
  }
  .device-detail-location-wrap {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .full-btn {
    width: 36px;
    height: 36px;
    cursor: pointer;
    background-color: #ffffff;
    color: #495057;
    line-height: 36px;
    text-align: center;
    margin-right: 17px;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    .icon {
      font-size: 16px;
    }
  }
  .tab-box {
    position: absolute;
    left: 16px;
    top: 16px;
    z-index: 190;
    &.tab {
      left: auto;
      right: 0;
    }
    .ub {
      margin-right: 16px;
      border-radius: 2px;
      overflow: hidden;
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
    }
    .ub-f1 {
      background-color: #ffffff;
      line-height: 36px;
      height: 36px;
      padding: 0 15px;
      color: #6c757d;
      font-size: 12px;
      cursor: pointer;
      &.cur {
        background-color: #0d9ae0;
        color: #ffffff;
      }
    }
  }
  .amap-tool {
    position: absolute;
    right: 16px;
    bottom: 16px;
    z-index: 199;
    .location {
      cursor: pointer;
      background-color: #ffffff;
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
      border-radius: 2px;
      width: 32px;
      height: 32px;
      text-align: center;
      line-height: 32px;
      .icon {
        color: #646464;
        font-size: 16px;
      }
    }
    .zoom {
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
      border-radius: 2px;
      margin-top: 10px;
      background-color: #ffffff;
      text-align: center;
      align-items: center;
      .icon {
        cursor: pointer;
        color: #646464;
        font-size: 16px;
        line-height: 37px;
      }
      .bar {
        background-color: rgba(0, 0, 0, 0.1);
        height: 1px;
        width: 24px;
      }
    }
  }
  .amap-info-content {
    position: relative;
    border-radius: 2px;
    padding: 16px 18px 16px 16px;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
  }
  .amap-info-close {
    display: none;
  }
  .address {
    color: #99a6ad;
    font-size: 12px;
    line-height: 22px;
    i {
      font-size: 14px;
      margin-right: 2px;
    }
  }
  .product {
    .img-box {
      width: 44px;
      height: 44px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .info {
      padding-left: 10px;
      h1 {
        color: #495057;
        line-height: 20px;
        font-size: 14px;
        margin-bottom: 3px;
        font-weight: bold;
      }
      p {
        line-height: 17px;
        font-size: 12px;
        color: #495057;
      }
    }
  }

  position: relative;
  margin: 16px;

  h1.tit {
    line-height: 44px;
    color: #394668;
    font-size: 14px;
    font-weight: bold;
    background: rgba(248, 249, 251, 1);
    padding: 0 16px;
    span {
      cursor: pointer;
      font-weight: normal;
      font-size: 12px;
      float: right;
      color: #6c757d;
    }
    .icon {
      color: #0d9ae0;
    }
    .up {
      display: block;
      transform: rotate(90deg);
    }
  }

  .aside-box {
    position: absolute;
    background-color: #ffffff;
    top: 16px;
    right: 16px;
    width: 300px;
    z-index: 190;
    border-radius: 2px;
    overflow: hidden;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
    .marks-tip {
      justify-content: space-between;
      line-height: 16px;
      color: #6c757d;
      font-size: 12px;
      margin-top: -6px;
    }
    .aside-tab {
      margin-top: 16px;
      margin-bottom: 18px;
      .ub-f1 {
        line-height: 26px;
        height: 28px;
        border: 1px solid #dee2e6;
        color: #6c757d;
        font-size: 12px;
        text-align: center;
        cursor: pointer;
        &:first-child {
          border-right: none;
          border-radius: 2px 0px 0px 2px;
        }
        &:last-child {
          border-left: none;
          border-radius: 0px 2px 2px 0px;
        }
        &.cur {
          border: none;
          background-color: #0d9ae0;
          color: #ffffff;
        }
      }
    }
  }
  .fence-list {
    position: absolute;
    background-color: #ffffff;
    top: 67px;
    right: 16px;
    width: 300px;
    z-index: 190;
    border-radius: 2px;
    overflow: hidden;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
    .add-fence {
      cursor: pointer;
      background: rgba(248, 249, 251, 1);
      border-radius: 2px;
      border: 1px dashed rgba(228, 228, 228, 1);
      color: rgba(73, 80, 87, 1);
      line-height: 32px;
      font-size: 12px;
      text-align: center;
      margin-top: 16px;
      .icon {
        color: #0d9ae0;
      }
    }
    ul {
      margin-top: 16px;
    }
    ul li {
      height: 38px;
      line-height: 38px;
      span {
        text-indent: 4px;
        color: #495057;
        font-size: 12px;
        cursor: pointer;
      }
      .icon {
        cursor: pointer;
        color: #0d9ae0;
        font-size: 13.5px;
        margin: 0 7px;
      }
      &.cur {
        background: rgba(248, 249, 251, 1);
        span {
          color: #0d9ae0;
        }
      }
      &.disable span {
        color: #d1d1d1;
      }
    }
  }
  .input-card {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 190;
    padding: 0.75rem 1.25rem;
    background-color: #fff;
    .btn {
      display: inline-block;
      text-align: center;
      white-space: nowrap;
      vertical-align: middle;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      border: 1px solid transparent;
      transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
      background-color: transparent;
      background-image: none;
      color: #25a5f7;
      border-color: #25a5f7;
      padding: 0.25rem 0.5rem;
      line-height: 1.5;
      border-radius: 1rem;
      -webkit-appearance: button;
      cursor: pointer;
    }
  }
}
#container {
  width: 100%;
  height: 100%;
}
</style>
